export default __webpack_public_path__ + "fd48c4065198e6c99542ae6918352843.png";